// extracted by mini-css-extract-plugin
export var animationContainer = "_hh-0";
export var asteriskIcon = "_hh-8";
export var conversationLeftSection = "_hh-4";
export var conversationListItem = "_hh-3";
export var conversationMiddleSection = "_hh-5";
export var conversationRightSection = "_hh-6";
export var detailsContent = "_hh-1";
export var listContainer = "_hh-7";
export var modalContent = "_hh-2";